export const ExpenseColumns = [
    {
        Header: "Date",
        accessor: "date",
    },
    {
        Header: "Description",
        accessor: "description",
    },
    {
        Header: "Bank",
        accessor: "bank",
    },
    {
        Header: "Account Number",
        accessor: "accountNumber",
    },
    {
        Header: "Expense Amount",
        accessor: "expenseAmount",
    },
    {
        Header: "Category",
        accessor: "category",
    },
    {
        Header: "Details",
        accessor: "details",
    },
    {
        Header: "Notes",
        accessor: "notes",
    },
]


export const ExpenseData = [
    {
        date: "September 1, 2024",
        description: "Monthly Service Fee for Business Checking Account",
        bank: "ABC Bank",
        accountNumber: "1234567890",
        expenseAmount: "$25.00",
        category: "Bank Fees",
        details: "Monthly fee for account maintenance, online services, and support.",
        notes: "Standard monthly fee.",
    },
    {
        date: "September 12, 2024",
        description: "Overdraft Fee",
        bank: "ABC Bank",
        accountNumber: "1234567890",
        expenseAmount: "$30.00",
        category: "Bank Fees",
        details: "Fee for overdrawing the business checking account.",
        notes: "One-time occurrence; resolved immediately.",
    },
    {
        date: "September 20, 2024",
        description: "ATM Withdrawal Fee (Non-network ATM)",
        bank: "DEF Bank",
        accountNumber: "1122334455",
        expenseAmount: "$2.50",
        category: "Bank Fees",
        details: "Fee for withdrawing cash from an ATM outside the bank’s network.",
        notes: "Avoid using non-network ATMs to prevent fees.",
    },
    {
        date: "September 25, 2024",
        description: "Account Maintenance Fee (Premium Account)",
        bank: "GHI Bank",
        accountNumber: "5566778899",
        expenseAmount: "$10.00",
        category: "Bank Fees",
        details: "Monthly fee for premium account features and enhanced services.",
        notes: "Includes additional benefits like higher transaction limits.",
    },
    {
        date: "September 5, 2024",
        description: "Wire Transfer Fee",
        bank: "XYZ Bank",
        accountNumber: "9876543210",
        expenseAmount: "$15.00",
        category: "Bank Fees",
        details: "Fee for sending an international wire transfer.",
        notes: "Charged per transaction.",
    },
]